/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<g transform="translate(-2 -2)" _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h18v18H0z"/><rect pid="1" _fill="#566473" transform="rotate(45 9 9)" x="8" width="2" height="18" rx="1"/><rect pid="2" _fill="#566473" transform="rotate(-45 9 9)" x="8" width="2" height="18" rx="1"/></g>'
  }
})
